/*
 * Copyright (c) 2008-present Sonatype, Inc.
 *
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/pro/attributions
 * Sonatype and Sonatype Nexus are trademarks of Sonatype, Inc. Apache Maven is a trademark of the Apache Foundation.
 * M2Eclipse is a trademark of the Eclipse Foundation. All other trademarks are the property of their respective owners.
 */
import Axios from 'axios';
import {assign} from 'xstate';

import {ExtJS, Utils} from '@sonatype/nexus-ui-plugin';

import UIStrings from '../../../../constants/UIStrings';

const {ERROR, DATASTORE_CONFIGURATION} = UIStrings;

export default Utils.buildFormMachine({
  id: 'DataStoreConfigurationForm'
}).withConfig({
  actions: {
    validate: assign({
      validationErrors: ({data}) => ({
        maximumConnectionPool: Utils.isInRange({value: data.maximumConnectionPool, min: 1, max: 3000})
      })
    }),
    setData: assign({
      data: (_, {data}) => data.data,
      pristineData: (_, {data}) => data.data
    }),

    logSaveError: (_, event) => {
      const error = event.data.data;
      if (error) {
        console.error(error);
      }
      ExtJS.showErrorMessage(DATASTORE_CONFIGURATION.MESSAGES.SAVE_ERROR);
    },
    logSaveSuccess: () => ExtJS.showSuccessMessage(DATASTORE_CONFIGURATION.MESSAGES.SAVE_SUCCESS),

    logLoadError: (_, event) => {
      const error = event.data.data;
      if (error) {
        console.error(error);
      }
      ExtJS.showErrorMessage(DATASTORE_CONFIGURATION.MESSAGES.LOAD_ERROR);
    }
  },
  services:
      {
        fetchData: () => Axios.get('/service/rest/internal/ui/datastore'),
        saveData: ({data}) => {
          return Axios.put('/service/rest/internal/ui/datastore', data);
        }
      }
});

